import PostAddIcon from "@mui/icons-material/PostAdd";
import ListTheme from "./List";
import ShowTheme from "./Show";
//params
import { THEMATIC_CATALOG } from "../../../../utils/constants";
export const THEME = "";
//permissions

export const resources = {
  isMenu: true,
  icon: <PostAddIcon />,
  name: THEMATIC_CATALOG,
  title: "Тематичен каталог",
  list: <ListTheme />,
  show: <ShowTheme />,
  permission: "editions",
};

//api url
